import { Edit, Trash } from '@styled-icons/boxicons-solid'
import { formatEmptyValue } from '../../../utils/common'
import Tooltip from '../../common/tooltip'

const CircuitRow = (props) => {
  return (
    <div className="flex flex-row flex-wrap items-center bg-white w-full py-2 px-3 border-b border-tracer-dark-blue text-black">
      <div className="flex flex-row w-full">
        <div className="flex w-3/12 items-center">
          <Tooltip message={props.name}>
            <div>{formatEmptyValue(props?.name)}</div>
          </Tooltip>
        </div>
        <div className="flex w-4/12 pl-6 items-center table_text">
          <Tooltip message={props.description}>
            <div>{formatEmptyValue(props?.description)}</div>
          </Tooltip>
        </div>
        <div className="flex w-3/12 pl-6 items-center table_text">
          <Tooltip message={props.signal_name?.name}>
            <div>{formatEmptyValue(props.signal_name?.name)}</div>
          </Tooltip>
        </div>
        <div className="flex w-2/12 pl-6 justify-end">
          <div>
            <span
              onClick={() => {
                props.onShowDetails()
              }}
              className="cursor-pointer p-2"
            >
              <Edit size="2rem" color="#0189E9" />
            </span>
          </div>
          <div>
            <span
              onClick={() => {
                props.onDelete()
              }}
              className="cursor-pointer p-2"
            >
              <Trash size="2rem" color="#0189E9" />
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CircuitRow
